import React from 'react';
import { Link } from 'react-router-dom';
import { SlCalender } from 'react-icons/sl';
import { FaRegClock } from 'react-icons/fa';
import { IoLocationOutline } from 'react-icons/io5';
import { GoArrowUpRight } from 'react-icons/go';

const EventsCard = ({ eventLink, imgSrc, title, artist, date, time, location, price }) => {
  return (
    <Link to={eventLink} className="whats-new-card" style={{ textDecoration: "none" }}>
      <div className="card rounded-top-4" >
        <div className="card-wrapper">
          <div>
            <img className="rounded-top-4 img-fluid" style={{ height: "20%", width: "100%", objectFit: "cover", objectPosition: "bottom" }} src={imgSrc} alt={title} />
          </div>
          <div className="p-3 mb-2 bg-white text-dark rounded-bottom-4">
            <h3 className="fw-bold">{title}</h3>
            <p className="fw-bold" style={{ fontSize: "18px" }}>{artist}</p>
            <div>
              <div className="d-flex justify-content-start">
                <SlCalender className="mt-2" />
                <p className="ms-2 mb-2 mt-1">{date}</p>
              </div>
              <div className="d-flex justify-content-start">
                <FaRegClock className="mt-2" />
                <p className="ms-2 mb-2 mt-1">{time}</p>
              </div>
              <div className="d-flex justify-content-start">
                <IoLocationOutline className="fs-5 mt-2" />
                <p className="ms-2 mb-2 mt-1">{location}</p>
              </div>
              <div className="d-flex justify-content-between gap-5 mt-3">
                <a
                  href={eventLink}
                  className="fw-bold fs-5 "
                  style={{ textDecoration: "none", color: "black" }}
                >
                  more info <GoArrowUpRight />
                </a>
                <p className="fw-semibold fs-4">{price}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default EventsCard;
